module.exports = __webpack_public_path__ + "static/spielregeln-566bc149604279eb1b56198ddc2dbd6a.pdf";